import { useEffect } from "react";
import { AUTHENTICATED_ROUTES, ROUTES } from "../configs/routes";
import { Cookie } from "../services/storage";
import { REDIRECT, REDIRECT_URI, REQUEST_NUMBER } from "../constants/storage";
import { UtilsUser } from "../utils/UtilsUser";
import { SP_SPDL_TICKET_NUMBER } from "../constants/ticketNumberRegex";
import { useLoginOptionHooks } from "./login-option-hooks";
import { useQuery } from "./query-hooks";
import { useHistory } from "react-router-dom";


  export const useAuthRouteLoginHandler = (): void => {
  const { toggleLoginModal, removeRedirectSession, handleLoginBasedOnGeoIp } = useLoginOptionHooks();
  const history = useHistory();
  const query = useQuery();
  const requestNumberCookie = Cookie.get(REQUEST_NUMBER);
  const redirectUrlParams = query.get("redirect");
    const timeOutDialog = localStorage.getItem("SHOW_TIMEOUT_DIALOG");
    const isTimeOutDialogOpen = timeOutDialog === "true";
    useEffect(() => {
      if (!redirectUrlParams || isTimeOutDialogOpen) return;
  
      // Will validate first if the params.requestNumber is a valid format, if not valid it will redirect to ERROR 404 page
      if (
        requestNumberCookie &&
        !requestNumberCookie.match(SP_SPDL_TICKET_NUMBER) &&
        !UtilsUser.isUserLoggedIn()
      ) {
        Cookie.remove(REQUEST_NUMBER);
        history.replace(ROUTES.ERROR_404);
        return () => {};
      }
      // To handle deep links with request details, we will check if it includes "/my-data"
      // This would also affect routes like "/my-data" and "/my-data/history"
      if (
        (AUTHENTICATED_ROUTES.includes(redirectUrlParams) ||
          redirectUrlParams.includes(ROUTES.MYDATA)) &&
        !isTimeOutDialogOpen
      ) {
        sessionStorage.setItem(REDIRECT, redirectUrlParams);
  
        handleLoginBasedOnGeoIp();
      }
      // cleanup function for triggering loginModal
      return () => {
        window.onpopstate = () => {
          window.history.replaceState(null, "", "/");
          removeRedirectSession();
          Cookie.remove(REQUEST_NUMBER);
          Cookie.remove(REDIRECT_URI);
          toggleLoginModal({
            isLoginModalOpen: false,
          });
        };
      };
    }, [redirectUrlParams]);
  }